import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-slide-products',
  templateUrl: './card-slide-products.component.html',
  styleUrls: ['./card-slide-products.component.scss']
})
export class CardSlideProductsComponent implements OnInit {
  @Input() data: any;
  constructor(
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  goto_page(path){
    this.router.navigate([path]);
  }



}
